import { toast } from 'react-toastify'

export function handleApiError(error) {
   // RTK Query error shape
   const data = error?.data

   // Case 1: class-validator errors (array)
   if (Array.isArray(data?.response)) {
      data.response.forEach((msg) => {
         toast.error(msg)
      })
      return
   }

   // Case 2: single backend message
   if (data?.message) {
      toast.error(data.message)
      return
   }

   // Case 3: fallback
   toast.error('Something went wrong. Please try again.')
}
